import {
    PRINTOUT_FOOTER_HEIGHT_VARIABLE,
    PRINTOUT_HEADER_HEIGHT_VARIABLE,
    PRINTOUT_REGION_BAND_ATTRIBUTE,
    PRINTOUT_REGION_BAND_CLASS,
    PRINTOUT_REGION_CLONE_CLASS,
    PRINTOUT_REGION_PLACED_ATTRIBUTE,
} from "./printoutRegionOptions";

// Repeating regions use measured screen bands and fixed print positioning.
export const printoutRegionBlockSx = {
    "& .printout-region": {
        boxSizing: "border-box",
        position: "relative",
        width: "100%",
    },
    [`& [${PRINTOUT_REGION_PLACED_ATTRIBUTE}]`]: {
        left: "var(--crqlar-printout-margin-left)",
        margin: 0,
        position: "absolute",
        right: "var(--crqlar-printout-margin-right)",
        zIndex: 3,
        "@media print": {
            bottom: "auto !important",
            left: "0 !important",
            position: "fixed !important",
            right: "0 !important",
            top: "0 !important",
        },
    },
    [`& [${PRINTOUT_REGION_PLACED_ATTRIBUTE}="footer"]`]: {
        "@media print": {
            bottom: "0 !important",
            top: "auto !important",
        },
    },
    [`& .${PRINTOUT_REGION_BAND_CLASS}`]: {
        boxSizing: "border-box",
        overflow: "hidden",
    },
    [`& .${PRINTOUT_REGION_CLONE_CLASS}`]: {
        pointerEvents: "none",
        userSelect: "none",
    },
};

export const editorPrintoutRegionChromeSx = {
    // The first page hosts the editable node while later pages host inert clones.
    // Paint their shared pagination bands so every page gets identical editor chrome.
    [`& .${PRINTOUT_REGION_BAND_CLASS}[${PRINTOUT_REGION_BAND_ATTRIBUTE}]`]: {
        backgroundColor: "rgba(37, 99, 235, 0.04)",
    },
};

export const PRINTOUT_HEADER_HEIGHT_VALUE = `var(${PRINTOUT_HEADER_HEIGHT_VARIABLE}, 0px)`;
export const PRINTOUT_FOOTER_HEIGHT_VALUE = `var(${PRINTOUT_FOOTER_HEIGHT_VARIABLE}, 0px)`;
